import { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateShipmentAddress2 } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function ShipmentAddress2Component () {
    const dispatch = useAppDispatch();
    const shipmentAddress2:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_address2);
    return (
        <div className="UpdateVerifyInput first_width">
        <label>Address Line 2</label>
        <input type="text" className="form-control" placeholder="Address Line 2" value={shipmentAddress2} onChange={t => 
         {
            dispatch(
             updateShipmentAddress2(t.target.value)
            )
         }
            }/>
      </div>
    );
}